"use client";

import React, { useContext, useEffect } from "react";
import { FormContext } from "@/contexts/FormDataContext";
import { useTranslation } from "@/hooks/useTranslation";
import { getServiceTitle } from "@/utils/Form/formServices";
import ZapIcon from "@/assets/icons/zap.svg";
import useServices from "./useServices";
import ServiceCard from "./ServiceCard";
import "./styles.scss";

const ServiceSelector = () => {
  const { t } = useTranslation();
  const { servicesDetails, formDetails, selectedMethod, setSelectedMethod } =
    useContext(FormContext)!;
  const { getServicePrice, getTime } = useServices();

  const handleMethodChange = (method: string) => {
    setSelectedMethod(method);
  };

  useEffect(() => {
    setSelectedMethod("form");
  }, [setSelectedMethod]);

  return (
    <div className={`Services-wrapper`}>
      <div className={`Services-header`}>
        <h3 className="Services__heading">{t("Select Your Passport Plan")}</h3>
        <p className="Services__paragraph">
          {t("Choose the service level that fits your timeline and budget")}
        </p>
      </div>
      <div className={`Services__options`}>
        {/* Card for Standard Form Service */}
        <ServiceCard
          name="form"
          title={t("Standard Service")}
          time={t("Regular Timeline")}
          price={formDetails.total || 0}
          selected={selectedMethod === "form"}
          handleChange={handleMethodChange}
          defaultChecked={true}
        />

        <div className="Services__divider">
          <span className="Services__divider-line" />
          <div className="Services__divider-chip">
            <ZapIcon />
            <span className="Services__divider-text">
              {t("Traveling soon? Don't let the wait hold you back")}
            </span>
          </div>
          <span className="Services__divider-line" />
        </div>

        {servicesDetails.map((service: any) => {
          const serviceName = service.pdf?.name;
          const formName = formDetails?.pdf?.name; // "DS-82", "DS-11", etc.
          const serviceTitle = getServiceTitle(formName, serviceName) || serviceName;
          const servicePrice = getServicePrice(serviceName);

          // If service price is not found, don't render the card
          if (!servicePrice) return null;

          return (
            <ServiceCard
              key={serviceName}
              name={serviceName}
              title={t(serviceTitle)}
              time={getTime(serviceName)}
              price={servicePrice}
              selected={selectedMethod === serviceName}
              handleChange={handleMethodChange}
            />
          );
        })}
      </div>
      <p className="Services__disclaimer">
        <i>{t("Processing times start once documents are received")}</i>
      </p>
    </div>
  );
};

export default ServiceSelector;
